import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { ReferenceItem } from '@spi/shared';

export function useReferenceLists() {
  return useQuery({
    queryKey: ['reference-lists'],
    queryFn: () => apiFetch<Record<string, ReferenceItem[]>>('/api/reference-lists'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useAdminReferenceLists() {
  return useQuery({
    queryKey: ['admin-reference-lists'],
    queryFn: () => apiFetch<Record<string, ReferenceItem[]>>('/api/admin/reference-lists'),
  });
}

export function useAddReferenceItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { category: string; value: string; sortOrder?: number }) =>
      apiFetch<ReferenceItem>('/api/admin/reference-lists', { method: 'POST', body: JSON.stringify(data) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin-reference-lists'] });
      qc.invalidateQueries({ queryKey: ['reference-lists'] });
    },
  });
}

export function useUpdateReferenceItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: number; value?: string; sortOrder?: number; active?: boolean }) =>
      apiFetch<ReferenceItem>(`/api/admin/reference-lists/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin-reference-lists'] });
      qc.invalidateQueries({ queryKey: ['reference-lists'] });
    },
  });
}

export function useDeleteReferenceItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      apiFetch(`/api/admin/reference-lists/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin-reference-lists'] });
      qc.invalidateQueries({ queryKey: ['reference-lists'] });
    },
  });
}
